import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Alert,
  FormControlLabel,
  Switch
} from '@mui/material';
import { adminService } from '../../services/adminService';

const CategorieServiceModal = ({ open, onClose, onSuccess, categorieService = null }) => {
  const [formData, setFormData] = useState({
    code: '',
    libelle: '',
    description: '',
    statut: true
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (categorieService) {
      setFormData({
        code: categorieService.code || '',
        libelle: categorieService.libelle || '',
        description: categorieService.description || '',
        statut: categorieService.statut !== undefined ? categorieService.statut : true
      });
    } else {
      setFormData({
        code: '',
        libelle: '',
        description: '',
        statut: true
      });
    }
    setError('');
  }, [categorieService, open]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      if (!formData.code.trim()) {
        throw new Error('Le code est obligatoire');
      }
      if (!formData.libelle.trim()) {
        throw new Error('Le libellé est obligatoire');
      }

      if (categorieService) {
        await adminService.updateCategorieService(categorieService.id, formData);
      } else {
        await adminService.createCategorieService(formData);
      }

      onSuccess();
      onClose();
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Une erreur est survenue');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {categorieService ? 'Modifier la catégorie de service' : 'Ajouter une catégorie de service'}
      </DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <TextField
            fullWidth
            label="Code"
            name="code"
            value={formData.code}
            onChange={handleChange}
            required
            margin="normal"
            disabled={!!categorieService}
            helperText={categorieService ? "Le code ne peut pas être modifié" : "Code unique de la catégorie"}
          />

          <TextField
            fullWidth
            label="Libellé"
            name="libelle"
            value={formData.libelle}
            onChange={handleChange}
            required
            margin="normal"
          />

          <TextField
            fullWidth
            label="Description"
            name="description"
            value={formData.description}
            onChange={handleChange}
            margin="normal"
            multiline
            rows={3}
          />

          <FormControlLabel
            control={
              <Switch
                checked={formData.statut}
                onChange={handleChange}
                name="statut"
              />
            }
            label="Statut actif"
            sx={{ mt: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} disabled={loading}>
            Annuler
          </Button>
          <Button type="submit" variant="contained" disabled={loading}>
            {loading ? 'Enregistrement...' : categorieService ? 'Modifier' : 'Créer'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default CategorieServiceModal;

